export default __webpack_public_path__ + "static/media/24_cut.d40b8967.jpg";